// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @constants
const {
    TIME_HORIZON_CHECK_ERROR,
    TIME_HORIZON_CHECK_WARNING,
} = require('../../raConstants/index');

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @utilites
const { FormattedText } = require('core/i18n').i18n;
const { formatDate } = require('utilities/dateHelper');

class RATimeHorizonCheck extends React.Component {
    buildErrorMessage(date) {
        return (
            <OKMessage type="warning">
                <FormattedText
                    value="raManagementPlan-raManagementPlan_errorMessage"
                    injectedStrings={[date]}
                />
            </OKMessage>
        );
    }

    buildEndDateWarningMessage(date) {
        return (
            <OKMessage type="warning">
                <FormattedText
                    value="raManagementPlan-raManagementPlan_endDateErrorMessage"
                    injectedStrings={[date]}
                />
            </OKMessage>
        );
    }

    buildWarningMessage(date) {
        let warningMessage;

        if (__CONTACT_CENTER__) {
            warningMessage = (
                <BlockInfo>
                    <FormattedText
                        value="raManagementPlan-raManagementPlan_warningMessage"
                        injectedStrings={[date]}
                    />
                </BlockInfo>
            );
        } else {
            warningMessage = (
                <OKMessage type="informative">
                    <FormattedText
                        value="raManagementPlan-raManagementPlan_warningMessage"
                        injectedStrings={[date]}
                    />
                </OKMessage>
            );
        }

        return (
            <div className="ra-management-plan-view__section-invest">
                {warningMessage}
            </div>
        );
    }

    render() {
        const { immTimeHorizonCheck, alterWarningMessage } = this.props;
        const status = immTimeHorizonCheck.get('status');
        const date = formatDate(immTimeHorizonCheck.get('HTPI'));
        if (status == TIME_HORIZON_CHECK_WARNING) {
            return alterWarningMessage
                ? this.buildEndDateWarningMessage(date)
                : this.buildWarningMessage(date);
        } else if (status == TIME_HORIZON_CHECK_ERROR) {
            return this.buildErrorMessage(date);
        }
        return null;
    }
}

RATimeHorizonCheck.propTypes = {
    immTimeHorizonCheck: PropTypes.object.isRequired,
    alterWarningMessage: PropTypes.bool,
};

module.exports = connect(state => ({
    immTimeHorizonCheck: state.raTimeHorizonCheck,
}))(RATimeHorizonCheck);
